import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import GridService from '../../components/tribe/tribe_services'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import Event1 from '../../assets/image/event1.jpg'
import Event2 from '../../assets/image/event2.jpg'
import Event3 from '../../assets/image/event3.jpg'
import BannerImage from '../../assets/image/strategy-organization/strategy2.jpg'
import strategy from '../../assets/image/strategy-organization/strategy.jpg'
import culture from '../../assets/image/strategy-organization/culture.jpg'
import it from '../../assets/image/strategy-organization/it.jpg'
import people from '../../assets/image/strategy-organization/people.jpg'
import system from '../../assets/image/strategy-organization/system.jpg'
import structur from '../../assets/image/strategy-organization/culture2.jpg'
let data_services=[
    {
        title:"Strategy",
        content:"We help our clients in developing and implementing their strategy in order to improve performance and achieve growth.",
        img:strategy,
        link:'/services/consulting/strategy'
    },
    {
        title:"Structure",
        content:"We help our clients in developing and implementing strategy-based organization structure that ensure their employees work effectively to achieve  …",
        img:structur,
        link:'/services/consulting/structur'
    },
    {
        title:"Change Management  & Culture",
        content:"We help our clients in identifying their pressing change issues, prioritizing and executing the areas for improvement in order to shape the organization …",
        img:culture,
        link:'/services/consulting/change'
    },
    {
        title:"System",
        content:"We help our clients in developing and improving their business process that will deliver values and satisfaction to customers.",
        img:system,
        link:'/services/consulting/system'
    },
    {
        title:"People",
        content:"We help our clients in developing and implementing people best practices methodology that will contribute to the company’s future growth and sustainability.",
        img:people,
        link:'/services/consulting/people'
    },
    {
        title:"IT Strategic  Solution",
        content:"We help our clients in developing and enhancing their performance management and business productivity systems in order to make informed decision … ",
        img:it,
        link:'/services/consulting/it'
    }
]
export default class index extends Component {
    render() {
        const image=[
            {image:BannerImage}
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='consulting-section'>
                    <Banner bread_crum={['Strategy and Organization','']} image={image} title="We enhance your execution capability" subtitle="We enhance our client organization and individual performance by providing world-class solutions through our first class team. We measure our success based on customer, employee, community, and shareholder satisfaction."/>
                    <br/><br/>
                    <div className='consulting-content'>
                        <h2>Our Services</h2>
                        <br/><br/>
                        <GridService data={data_services}/>
                        <br/><br/>
                        <div className='success-story' >                        
                            <h2>Success Story </h2>
                            &nbsp;&nbsp;&nbsp;
                            <div style={{width:1,height:40,backgroundColor:'grey'}}></div>
                            &nbsp;&nbsp;&nbsp;
                            <p>Our success journey</p>
                        </div>
                        <br/><br/>
                        <div className='list-section'>
                           <div className='list'>
                               <div className='bullets'>
                                   <div className='list-bullets'></div>
                               </div>
                               <div className='list-content'>
                                   <b>Best Consultant Award SLA from BPJS TK</b>
                                   <p>Performance Management and Service Level Agreement (SLA) development project at BPJS Ketenagakerjaan</p>
                               </div>
                           </div>
                           <br/>
                           <div className='list'>
                               <div className='bullets'>
                                   <div className='list-bullets'></div>
                               </div>
                               <div className='list-content'>
                                   <b>Wordclass acknowledgment BSC</b>
                                   <p>Best implementation Balanced Scorecard in CNOOC Indonesia</p>
                               </div>
                           </div>
                           <br/>
                           <div className='list'>
                               <div className='bullets'>
                                   <div className='list-bullets'></div>
                               </div>
                               <div className='list-content'>
                                   <p>We helped many large industries (property, construction, manufacturing, bank, etc.) for both public and private services in Indonesia, on developing their vision, mission, destination statement, conducting their strategic analysis and developing their strategy, also implementing their balanced scorecard-based strategy and performance management system.</p>
                               </div>
                           </div>
                           <br/>
                           <div className='list'>
                               <div className='bullets'>
                                   <div className='list-bullets'></div>
                               </div>
                               <div className='list-content'>
                                   
                                   <p>We helped Indonesian state-owned companies (natural gas transportation and oil) and biggest mining company on developing their process mapping for process management improvement and governance process, also formulating their Standard Operating Procedure.</p>
                               </div>
                           </div>
                           <br/>
                           <div className='list'>
                               <div className='bullets'>
                                   <div className='list-bullets'></div>
                               </div>
                               <div className='list-content'>
                                   <p>We helped one of the top 10 insurance company in Indonesia on developing and aligning their strategy-based organization structure, job profile, job evaluation, career path and succession plan, and developing their compensation and benefit system and we helped a top refractory manufacturer in Indonesia on developing a performance-based compensation and benefit structure.</p>
                               </div>
                           </div>
                           <br/>
                           <div className='list'>
                               <div className='bullets'>
                                   <div className='list-bullets'></div>
                               </div>
                               <div className='list-content'>
                                   <p>We helped a top property and shopping mall company on conducting their employee engagement survey and creating development programs to retain employees and improve their business, also build a comprehensive roadmap of Human Capital transformation.</p>
                               </div>
                           </div>
                           <br/>
                           <div className='list'>
                               <div className='bullets'>
                                   <div className='list-bullets'></div>
                               </div>
                               <div className='list-content'>
                                   <p>We helped a large packaging manufacturer company in Indonesia on conducting their corporate culture assessment and portraying the current culture and generating core values from desired future culture.</p>
                               </div>
                           </div>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
